function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "5DAB8465-2069-41DE-8F4D-465F37789F6F");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Styleguide-+-UI-Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Styleguide",
  transform: "translate(-492.000000, -6320.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Stake",
  transform: "translate(492.000000, 6320.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.25,2 C21.6642136,2 22,2.33578644 22,2.75 L22,20.75 L22,20.75 C22,21.1296958 21.7178461,21.443491 21.3517706,21.4931534 L21.25,21.5 L21.25,21.5 L10.75,21.5 C10.3357864,21.5 10,21.1642136 10,20.75 C10,20.3357864 10.3357864,20 10.75,20 L20.5,20 L20.5,3.5 L10.75,3.5 C10.3357864,3.5 10,3.16421356 10,2.75 C10,2.33578644 10.3357864,2 10.75,2 L21.25,2 L21.25,2 Z M10.2179295,7.22016582 C10.4883192,6.93843176 10.9359039,6.9292353 11.217638,7.19962496 C11.2246249,7.20633052 11.2314733,7.21317892 11.2381788,7.22016582 L11.2381788,7.22016582 L15.1647505,11.3114799 L15.2438559,11.4045462 C15.5339087,11.7910889 15.5075403,12.3391717 15.1647505,12.6963435 L15.1647505,12.6963435 L14.8090513,13.0669663 L14.805,13.063 L11.2381788,16.7798342 C11.2314733,16.7868211 11.2246249,16.7936695 11.217638,16.800375 C10.9359039,17.0707647 10.4883192,17.0615682 10.2179295,16.7798342 C9.93286805,16.4828127 9.93286805,16.013801 10.2179295,15.7167795 L10.2179295,15.7167795 L13.063,12.752 L2.75169314,12.7516931 C2.33654448,12.7516931 2,12.4151487 2,12 C2,11.5848513 2.33654448,11.2483069 2.75169314,11.2483069 L2.75169314,11.2483069 L13.064,11.249 L10.2179295,8.28322046 L10.1472531,8.19820882 C9.93522393,7.90234556 9.95878273,7.49018532 10.2179295,7.22016582 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
}))));

var SvgIconStake = function SvgIconStake(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStake, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Stake.18f54a23.svg";
export { ForwardRef as ReactComponent };